var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex_center"},[(_vm.isCheck)?_c('i',{staticClass:"fa-check fa"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }